import {Box, Stack, Text} from '@chakra-ui/react';

// Quiet, single-ring loader for full-view loading states.
// One thin opal-blue arc on a soft track. Calm, minimal, on-brand —
// nothing more than what's needed to signal "we're working on it".
const ViewLoader = ({
  label = 'Loading…',
  minH = '100vh',
  bg,
  size = 36,
  color = '#727272',
}: Record<string, any>) => {
  return (
    <Box
      minH={minH}
      w="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg={bg}
    >
      <Stack align="center" spacing={4}>
        <Box
          w={`${size}px`}
          h={`${size}px`}
          borderRadius="full"
          borderWidth="1px"
          borderStyle="solid"
          borderColor="rgba(30, 159, 212, 0.15)"
          sx={{
            borderTopColor: '#1E9FD4',
            '@keyframes view-loader-spin': {
              from: {transform: 'rotate(0deg)'},
              to: {transform: 'rotate(360deg)'},
            },
            '@media (prefers-reduced-motion: reduce)': {
              animation: 'none !important',
            },
          }}
          animation="view-loader-spin 0.9s linear infinite"
        />
        {label ? (
          <Text
            fontFamily="'Figtree', sans-serif"
            fontSize="sm"
            fontWeight="normal"
            color={color}
          >
            {label}
          </Text>
        ) : null}
      </Stack>
    </Box>
  );
};

export default ViewLoader;
